export var Constants;
(function (Constants) {
    Constants["ICON_FADED"] = "#cccccc";
    Constants["ICON_DARK_GREY"] = "#8CA4A8";
    Constants["TEXT_TITLE"] = "#000000";
    Constants["TEXT_SUBTITLE"] = "#6b7280";
    // BLACK / WHITE
    Constants["TEXT_BLACK"] = "#000000";
    Constants["TEXT_WHITE"] = "#ffffff";
    // GRAY SCALE (Most used for text)
    Constants["TEXT_GRAY_50"] = "#f9fafb";
    Constants["TEXT_GRAY_100"] = "#f3f4f6";
    Constants["TEXT_GRAY_200"] = "#e5e7eb";
    Constants["TEXT_GRAY_300"] = "#d1d5db";
    Constants["TEXT_GRAY_400"] = "#9ca3af";
    Constants["TEXT_GRAY_500"] = "#6b7280";
    Constants["TEXT_GRAY_600"] = "#4b5563";
    Constants["TEXT_GRAY_700"] = "#374151";
    Constants["TEXT_GRAY_800"] = "#1f2937";
    Constants["TEXT_GRAY_900"] = "#111827";
    // PRIMARY TEXT COLORS (Tailwind defaults)
    Constants["TEXT_RED_500"] = "#ef4444";
    Constants["TEXT_ORANGE_500"] = "#f97316";
    Constants["TEXT_AMBER_500"] = "#f59e0b";
    Constants["TEXT_YELLOW_500"] = "#eab308";
    Constants["TEXT_LIME_500"] = "#84cc16";
    Constants["TEXT_GREEN_500"] = "#22c55e";
    Constants["TEXT_EMERALD_500"] = "#10b981";
    Constants["TEXT_TEAL_500"] = "#14b8a6";
    Constants["TEXT_CYAN_500"] = "#06b6d4";
    Constants["TEXT_SKY_500"] = "#0ea5e9";
    Constants["TEXT_BLUE_500"] = "#3b82f6";
    Constants["TEXT_INDIGO_500"] = "#6366f1";
    Constants["TEXT_VIOLET_500"] = "#8b5cf6";
    Constants["TEXT_PURPLE_500"] = "#a855f7";
    Constants["TEXT_FUCHSIA_500"] = "#d946ef";
    Constants["TEXT_PINK_500"] = "#ec4899";
    Constants["TEXT_ROSE_500"] = "#f43f5e";
    // DARK TEXT VARIANTS (Better contrast text)
    Constants["TEXT_RED_700"] = "#b91c1c";
    Constants["TEXT_GREEN_700"] = "#15803d";
    Constants["TEXT_BLUE_700"] = "#1d4ed8";
    Constants["TEXT_PURPLE_700"] = "#7e22ce";
    Constants["TEXT_ORANGE_700"] = "#c2410c";
    Constants["TEXT_YELLOW_700"] = "#a16207";
    // MUTED / SECONDARY TEXT
    Constants["TEXT_GRAY_MUTED"] = "#6b7280";
    Constants["TEXT_GRAY_LIGHT"] = "#9ca3af";
    Constants["TEXT_GRAY_FADED"] = "#d1d5db";
})(Constants || (Constants = {}));
export var BackgroundColors;
(function (BackgroundColors) {
    // BASE BACKGROUND
    BackgroundColors["BG_WHITE"] = "#ffffff";
    BackgroundColors["BG_BLACK"] = "#000000";
    // GRAY SCALE BACKGROUNDS (Most common UI backgrounds)
    BackgroundColors["BG_GRAY_50"] = "#f9fafb";
    BackgroundColors["BG_GRAY_100"] = "#f3f4f6";
    BackgroundColors["BG_GRAY_200"] = "#e5e7eb";
    BackgroundColors["BG_GRAY_300"] = "#d1d5db";
    BackgroundColors["BG_GRAY_400"] = "#9ca3af";
    BackgroundColors["BG_GRAY_500"] = "#6b7280";
    BackgroundColors["BG_GRAY_600"] = "#4b5563";
    BackgroundColors["BG_GRAY_700"] = "#374151";
    BackgroundColors["BG_GRAY_800"] = "#1f2937";
    BackgroundColors["BG_GRAY_900"] = "#111827";
    // PRIMARY BRAND-LIKE BACKGROUNDS
    BackgroundColors["BG_RED_500"] = "#ef4444";
    BackgroundColors["BG_ORANGE_500"] = "#f97316";
    BackgroundColors["BG_AMBER_500"] = "#f59e0b";
    BackgroundColors["BG_YELLOW_500"] = "#eab308";
    BackgroundColors["BG_LIME_500"] = "#84cc16";
    BackgroundColors["BG_GREEN_500"] = "#22c55e";
    BackgroundColors["BG_EMERALD_500"] = "#10b981";
    BackgroundColors["BG_TEAL_500"] = "#14b8a6";
    BackgroundColors["BG_CYAN_500"] = "#06b6d4";
    BackgroundColors["BG_SKY_500"] = "#0ea5e9";
    BackgroundColors["BG_BLUE_500"] = "#3b82f6";
    BackgroundColors["BG_INDIGO_500"] = "#6366f1";
    BackgroundColors["BG_VIOLET_500"] = "#8b5cf6";
    BackgroundColors["BG_PURPLE_500"] = "#a855f7";
    BackgroundColors["BG_FUCHSIA_500"] = "#d946ef";
    BackgroundColors["BG_PINK_500"] = "#ec4899";
    BackgroundColors["BG_ROSE_500"] = "#f43f5e";
    // LIGHT BACKGROUND VARIANTS (Cards / Sections)
    BackgroundColors["BG_RED_100"] = "#fee2e2";
    BackgroundColors["BG_GREEN_100"] = "#dcfce7";
    BackgroundColors["BG_BLUE_100"] = "#dbeafe";
    BackgroundColors["BG_YELLOW_100"] = "#fef9c3";
    BackgroundColors["BG_PURPLE_100"] = "#f3e8ff";
    BackgroundColors["BG_ORANGE_100"] = "#ffedd5";
    // DARK BACKGROUND VARIANTS (Buttons / Headers / Highlights)
    BackgroundColors["BG_RED_700"] = "#b91c1c";
    BackgroundColors["BG_GREEN_700"] = "#15803d";
    BackgroundColors["BG_BLUE_700"] = "#1d4ed8";
    BackgroundColors["BG_PURPLE_700"] = "#7e22ce";
    BackgroundColors["BG_ORANGE_700"] = "#c2410c";
    BackgroundColors["BG_YELLOW_700"] = "#a16207";
    // MUTED SURFACE BACKGROUNDS
    BackgroundColors["BG_SURFACE_PRIMARY"] = "#ffffff";
    BackgroundColors["BG_SURFACE_SECONDARY"] = "#f9fafb";
    BackgroundColors["BG_SURFACE_TERTIARY"] = "#f3f4f6";
    BackgroundColors["BG_SURFACE_MUTED"] = "#e5e7eb";
})(BackgroundColors || (BackgroundColors = {}));
